import React from 'react';
import useTheme from 'branding/theme';
/** not to be used outside of the Select component */
const ListTrigger = ({ handleFocus, handleBlur, children, disabled, isScrollable }) => {
    const { inputs: { selectStyles: { trigger } }, utility: { cursor: { pointer, notAllowed } } } = useTheme();
    const mergedStyles = {
        ...trigger,
        ...(isScrollable && { width: 'calc(100% - 0.6rem)' }),
        ...(disabled ? notAllowed : pointer)
    };
    return (React.createElement("summary", { onFocus: handleFocus, onBlur: handleBlur, style: mergedStyles }, children));
};
export default ListTrigger;
//# sourceMappingURL=ListTrigger.js.map